// ConsultationCTA.jsx
import { useState, useRef, useEffect } from 'react';
import AppointmentForm from './AppointmentForm';

export default function ConsultationCTA() {
  const [showForm, setShowForm] = useState(false);
  const formRef = useRef(null);

  /* auto-scroll so the form is fully visible after it appears */
  useEffect(() => {
    if (showForm && formRef.current) {
      const { bottom } = formRef.current.getBoundingClientRect();
      const winH = window.innerHeight;
      if (bottom > winH) {
        window.scrollBy({ top: bottom - winH + 20, behavior: 'smooth' });
      }
    }
  }, [showForm]);

  return (
    <div className="text-center mt-10">
      <p>
        📞 <strong>Not sure which one suits you best?</strong>
      </p>

      {showForm ? (
        <div ref={formRef} className="mt-5">
          <AppointmentForm />
        </div>
      ) : (
        <button
          type="button"
          onClick={() => setShowForm(true)}
          className="text-brand text-lg hover:underline focus:outline-none"
        >
          Contact&nbsp;us
        </button>
      )}
    </div>
  );
}
